import { DropdownContext } from 'components/DropdownContext';
import { ContractStatusEnum, ContractChangeStatusEnum } from 'gql/graphql';
import { useAccess } from 'hooks/useAccess';

import { useMemo } from 'react';

export const AgreementsKebabMenu = ({
    currentId,
    currentStatus,
    deleteHandler,
    editHandler,
    handleUploadAgreement,
    isDisabledByProjectStatus,
    statusContract,
    ...propsDropdown
}: {
    currentId: number;
    currentStatus: ContractChangeStatusEnum;
    deleteHandler: ({ id, status }: { id: number; status: ContractChangeStatusEnum }) => void;
    editHandler: (id: number, status: ContractChangeStatusEnum) => void;
    handleUploadAgreement: (id: number, status: ContractChangeStatusEnum) => void;
    isDisabledByProjectStatus: boolean;
    statusContract?: ContractStatusEnum;
}) => {
    const { additionalAgreement: additionalAgreementRules } = useAccess();

    const kebabGroups = useMemo(
        () => [
            {
                id: 1,
            },
            {
                id: 2,
            },
        ],
        [],
    );

    const isContractStatusWork = statusContract === ContractStatusEnum.InImplementation;
    const disabledByStatus = useMemo(() => currentStatus !== ContractChangeStatusEnum.Formation, [currentStatus]);

    const kebabItems = useMemo(
        () => [
            {
                label: 'Редактировать реквизиты ДС',
                action: () => editHandler?.(currentId, currentStatus),
                groupId: 1,
                disabled: isDisabledByProjectStatus || !isContractStatusWork || !additionalAgreementRules?.canEdit,
            },
            {
                label: 'Выгрузить',
                action: () => handleUploadAgreement(currentId, currentStatus),
                groupId: 1,
                disabled: !additionalAgreementRules?.canUploadToExcel,
            },
            {
                label: 'Удалить',
                action: () =>
                    deleteHandler?.({
                        id: currentId,
                        status: currentStatus,
                    }),
                groupId: 1,
                disabled:
                    disabledByStatus ||
                    isDisabledByProjectStatus ||
                    !isContractStatusWork ||
                    !additionalAgreementRules?.canDelete,
            },
        ],
        [
            additionalAgreementRules?.canDelete,
            additionalAgreementRules?.canEdit,
            additionalAgreementRules?.canUploadToExcel,
            currentId,
            currentStatus,
            deleteHandler,
            disabledByStatus,
            editHandler,
            handleUploadAgreement,
            isContractStatusWork,
            isDisabledByProjectStatus,
        ],
    );

    return <DropdownContext items={kebabItems} groups={kebabGroups} {...propsDropdown} />;
};

AgreementsKebabMenu.displayName = 'AgreementsKebabMenu';
